<section
	class="captions-section settings-section"
	*ngIf="shouldShowClosedCaptionsToggle() && !volumeActive">
	<span translate="player-controls_subtitles"></span>
	<mat-slide-toggle
		color="primary"
		[hideIcon]="true"
		[attr.aria-label]="captionsEnabled ? ('player-controls_captions-off' | translate) : ('player-controls_captions-on' | translate)"
		class="captions-toggle"
		analytics-on="click"
		[attr.analytics-event]="player.captionsEnabled() ? 'Hide closed captions' : 'Show closed captions'"
		analytics-category="playback controls"
		[(ngModel)]="captionsEnabled"
		(change)="toggleCaps()">
	</mat-slide-toggle>
</section>
<section
	class="audio-description-section settings-section"
	*ngIf="options.shouldDisplayAudioDescriptionButton && !volumeActive">
	<span translate="player-controls_audio-description"></span>
	<mat-slide-toggle
		color="primary"
		[hideIcon]="true"
		[attr.aria-label]="audioDescriptionEnabled ? ('player-controls_audio-description-off' | translate) : ('player-controls_audio-description-on' | translate)"
		class="audio-description-toggle"
		analytics-on="click"
		[attr.analytics-event]="audioDescriptionEnabled ? 'Disable audio description' : 'Enable audio description'"
		analytics-category="playback controls"
		[(ngModel)]="audioDescriptionEnabled"
		(change)="toggleAudioDescription.emit()">
	</mat-slide-toggle>
</section>
<section
	class="comment-captions-section settings-section"
	*ngIf="options.toggleCommentCaptionsCallback != null && !volumeActive">
	<span translate="player-controls_overlay-comments"></span>
	<mat-slide-toggle
		color="primary"
		[hideIcon]="true"
		[attr.aria-label]="commentCaptionsEnabled ? ('player-controls_overlay-comments-off' | translate) : ('player-controls_overlay-comments-on' | translate)"
		class="comment-captions-toggle"
		[(ngModel)]="commentCaptionsEnabled"
		(change)="toggleCommentCaptions.emit()">
	</mat-slide-toggle>
</section>
<section
	class="live-mode-section settings-section"
	data-cy="live-mode-section"
	*ngIf="options.liveStream && !volumeActive">
	<span translate="player-controls_live-stream"></span>
	<mat-slide-toggle
		color="primary"
		[hideIcon]="true"
		[attr.aria-label]="liveMode ? ('player-controls_live-stream-off' | translate) : ('player-controls_live-stream-on' | translate)"
		[(ngModel)]="liveMode"
		(change)="toggleLiveMode()">
	</mat-slide-toggle>
</section>
<section
	class="source-volume-section settings-section"
	*ngIf="shouldShowSourceSyncAndAudio() && !(settingsActive && !isXSmallScreen)">
	<span translate="player-controls_volume1"></span>
	<div class="volume-container">
		<mat-slider
			#sourceVolumeSlider
			color="primary"
			class="volume-slider"
			[min]="0"
			[max]="100"
			[disabled]="getSourceMute() && sourceVolumeLevel !== 0"
			[attr.aria-label]="'player-controls_volume-slider_volume-handles' | translate"
			[step]="1">
			<input
				[(ngModel)]="sourceVolumeLevel"
				matSliderThumb
				(input)="updateSourceVolumeLevel(sourceSliderThumb.value)"
				#sourceSliderThumb="matSliderThumb"
				(change)="updateSourceVolumeLevel(sourceSliderThumb.value)" />
		</mat-slider>
		<button
			type="button"
			class="mute-button"
			[attr.aria-label]="(getSourceMute() ? 'microphone-unmute' : 'microphone-mute') | translate"
			(click)="toggleSourceMute()">
			<i [class]="getSourceMute() ? 'ficon-app-volume-mute' : 'ficon-app-volume-high'"></i>
		</button>
	</div>
</section>
<section
	class="volume-section settings-section"
	*ngIf="(!options.liveStream || liveMode) && !(settingsActive && !isXSmallScreen)">
	<span translate="player-controls_volume-x" [translateParams]="{num: shouldShowSourceSyncAndAudio() ? '2' : ''}"></span>
	<div class="volume-container">
		<mat-slider
			#mainVolumeSlider
			color="primary"
			class="volume-slider"
			[min]="0"
			[max]="100"
			[disabled]="getMute() && volumeLevel !== 0"
			[attr.aria-label]="'player-controls_volume-slider_volume-handles' | translate"
			[step]="1">
			<input
				[(ngModel)]="volumeLevel"
				matSliderThumb
				(input)="updateVolumeLevel(volumeThumb.value)"
				#volumeThumb="matSliderThumb"
				(change)="updateVolumeLevel(volumeThumb.value)" />
		</mat-slider>
		<button
			class="mute-button"
			type="button"
			[attr.aria-label]="(getMute() ? 'microphone-unmute' : 'microphone-mute') | translate"
			(click)="toggleMute()">
			<i [class]="getMute() ? 'ficon-app-volume-mute' : 'ficon-app-volume-high'"></i>
		</button>
	</div>
</section>
<div *ngIf="options.showVolumeWarning" class="volume-warning" translate="player-controls_source-volume-warning"></div>
